// extracted by mini-css-extract-plugin
export var chevron = "_jf-2";
export var dropdownItems = "_jf-0";
export var item = "_jf-1";